import { extend } from 'flarum/common/extend';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import app from 'flarum/forum/app';

export default function extendNotificationGridWithTeams() {
  extend(NotificationGrid.prototype, 'notificationMethods', function (items) {
    items.add('teams', {
      name: 'teams',
      icon: 'fab fa-microsoft',
      label: app.translator.trans('sbp-jm-flarum-msteams-webhook.forum.notification_method.teams'),
    });
  });
}